import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import useUserData from "./data/authorsTableData";
import * as XLSX from "xlsx";

function Tables() {
  const { columns, rows, users } = useUserData();

  console.log("Total Users:", users.length);

  const [searchQuery1, setSearchQuery1] = useState("");
  const [searchQuery2, setSearchQuery2] = useState("");
  const [sortOrder, setSortOrder] = useState("none");

  const filteredUsers = rows.filter((user) => {
    const name = user.user.props.name?.toLowerCase() || "";
    const contact = user.contact?.props?.children?.toString()?.toLowerCase() || "";

    const query1 = searchQuery1.toLowerCase();
    const query1Match = !searchQuery1 || name.includes(query1) || contact.includes(query1);

    const query2Match =
      !searchQuery2 ||
      (user.malaCount && user.malaCount.props.children
        ? user.malaCount.props.children.toString().includes(searchQuery2.toLowerCase())
        : false);

    return query1Match && query2Match;
  });

  const sortedUsers = [...filteredUsers].sort((a, b) => {
    const malaCountA = a.malaCount.props.children || 0;
    const malaCountB = b.malaCount.props.children || 0;

    if (sortOrder === "high-to-low") {
      return malaCountB - malaCountA;
    } else if (sortOrder === "low-to-high") {
      return malaCountA - malaCountB;
    } else {
      return 0;
    }
  });

  const exportToExcel = () => {
    const filteredRawUsers = users.filter((user) => {
      const name = `${user.firstName || ""} ${user.lastName || ""}`.toLowerCase();
      const malaCountStr = user.malaCount?.toString() || "0";
      return (
        name.includes(searchQuery1.toLowerCase()) &&
        malaCountStr.includes(searchQuery2.toLowerCase())
      );
    });

    const sortedRawUsers = [...filteredRawUsers].sort((a, b) => {
      const malaA = a.malaCount || 0;
      const malaB = b.malaCount || 0;
      if (sortOrder === "high-to-low") return malaB - malaA;
      if (sortOrder === "low-to-high") return malaA - malaB;
      return 0;
    });

    const formatTime = (seconds) => {
      if (!seconds) return "N/A";
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      return `${hours ? `${hours}hr ` : ""}${minutes}min`;
    };

    const formatDate = (timestamp) =>
      timestamp ? new Date(timestamp).toLocaleDateString() : "N/A";

    const formattedData = sortedRawUsers.map((user) => ({
      Name: `${user.firstName || ""} ${user.lastName || ""}`,
      ProfileImage: `${user.profileImage || ""}`,
      Contact: `${user.countryCode || ""} ${user.mobileNumber || ""}`,
      TasksWatchTime: formatTime(user.dailyTaskWatchTime),
      VideosWatchTime: formatTime(user.dailyVideoWatchTime),
      MalaCount: user.malaCount || 0,
      RegistrationDate: formatDate(user.registrationDate),
      CollectionRequest: user.isCollectionRequestSubmitted ? "Yes" : "No",
      IsDeleted: user.isDeleted ? "Yes" : "No",
      FollowingOnInstagram: user.isFollowingOnInstagram ? "Yes" : "No",
      SubscribedOnYouTube: user.isSubscribedOnYoutube ? "Yes" : "No",
      GodMalaImage: user.selectedGodMalaImage || "No Image",
    }));

    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Users");
    XLSX.writeFile(wb, "Users_Details.xlsx");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Users
                </MDTypography>
              </MDBox>

              <MDBox pt={3} pb={3} mx={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={2}>
                    <MDBox mt={2}>
                      <MDTypography variant="h6">Total Users : {users.length}</MDTypography>
                    </MDBox>
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      label="Search by Name or Mobile No."
                      variant="outlined"
                      fullWidth
                      value={searchQuery1}
                      onChange={(e) => setSearchQuery1(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      label="Search by Mala Count"
                      variant="outlined"
                      fullWidth
                      value={searchQuery2}
                      onChange={(e) => setSearchQuery2(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <FormControl fullWidth sx={{ display: "flex", height: "44px" }}>
                      <InputLabel>Sort by Mala Count</InputLabel>
                      <Select
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}
                        label="Sort by Mala Count"
                        sx={{ height: "100%" }}
                      >
                        <MenuItem value="none">None</MenuItem>
                        <MenuItem value="high-to-low">High to Low</MenuItem>
                        <MenuItem value="low-to-high">Low to High</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={exportToExcel}
                      style={{ color: "white" }}
                    >
                      Export to Excel
                    </Button>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox>
                <DataTable
                  table={{ columns, rows: sortedUsers }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={true}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Tables;
